<template>
  <div>
    <div id="strategy-analytics">
      <div class="top">
        <img
          class="returns"
          src="@/assets/img/backleftarrow.png"
          alt=""
          @click="back()"
        />
      </div>

      <div class="mid">
        <!-- 资产概览标题 -->
        <div class="section-title single">
          资产概览
        </div>

        <!-- 总资产 -->
        <div class="total-assets">
          <div class="assets-label">总资产</div>
          <div class="assets-value">
            {{ formatNumber(positionInfo.totalBalance) }}
            <span
              class="assets-change"
              :class="{
                positive: positionInfo.todayFloatPL > 0,
                negative: positionInfo.todayFloatPL < 0,
                zero: positionInfo.todayFloatPL === 0,
              }"
            >
              {{ formatPL(positionInfo.todayFloatPL) }} ({{
                formatPercent(positionInfo.todayFloatRate)
              }})
            </span>
          </div>
          <div class="stat-row">
            <div class="stat-item">
              <div class="stat-label">可用资金</div>
              <div class="stat-value">{{ formatCurrency(positionInfo.cashBalance) }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">持仓市值</div>
              <div class="stat-value">{{ formatNumber(positionInfo.positionBalance) }}</div>
            </div>
          </div>
          <div class="stat-row">
            <div class="stat-item">
              <div class="stat-label">持仓浮动盈亏</div>
              <div
                class="stat-value"
                :class="{
                  positive: positionInfo.totalFloatPL > 0,
                  negative: positionInfo.totalFloatPL < 0,
                  zero: positionInfo.totalFloatPL === 0,
                }"
              >
                {{ formatPL(positionInfo.totalFloatPL) }}
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-label">今日浮动盈亏</div>
              <div
                class="stat-value"
                :class="{
                  positive: positionInfo.todayFloatPL > 0,
                  negative: positionInfo.todayFloatPL < 0,
                  zero: positionInfo.todayFloatPL === 0,
                }"
              >
                {{ formatPL(positionInfo.todayFloatPL) }}
              </div>
            </div>
          </div>
        </div>

        <!-- 持仓明细 -->
        <div class="section-title single">
          持仓明细
          <div v-if="positionList.length > 0" class="ai-live-date">
            <div class="current-date">
              更新于{{positionList[0].date.split("T")[0]}}
            </div>
          </div>
        </div>

        <div class="holdings-section" v-if="positionList.length > 0">
          <div class="holdings-table">
            <!-- 固定列 - 股票代码 -->
            <div class="fixed-column" ref="fixedColumn">
              <div class="fixed-header">股票代码</div>
              <div class="fixed-content">
                <div
                  class="fixed-cell"
                  v-for="(item, index) in positionList"
                  :key="index"
                >
                  {{ item.ticker }}
                </div>
              </div>
            </div>

            <!-- 可滚动列 -->
            <div class="scrollable-columns" @scroll="handleTableScroll">
              <!-- 表头 -->
              <div class="scrollable-header">
                <div class="scrollable-header-cell">持仓数量</div>
                <div class="scrollable-header-cell">成本价</div>
                <div class="scrollable-header-cell">现价</div>
                <div class="scrollable-header-cell">市值</div>
                <div class="scrollable-header-cell">持仓盈亏</div>
                <div class="scrollable-header-cell">收益率</div>
              </div>

              <!-- 数据行 -->
              <div class="scrollable-content">
                <div
                  class="scrollable-row"
                  v-for="(item, index) in positionList"
                  :key="index"
                >
                  <div class="scrollable-cell">{{ formatNumber(item.shares) }}</div>
                  <div class="scrollable-cell">{{ formatNumber(item.costPrice) }}</div>
                  <div class="scrollable-cell">{{ formatNumber(item.nowPrice) }}</div>
                  <div class="scrollable-cell">{{ formatNumber(item.marketValue) }}</div>
                  <div class="scrollable-cell" :class="{
                    positive: item.positionPL > 0,
                    negative: item.positionPL < 0,
                    zero: item.positionPL === 0,
                  }">{{ formatPL(item.positionPL) }}</div>
                  <div class="scrollable-cell" :class="{
                    positive: item.returnRate > 0,
                    negative: item.returnRate < 0,
                    zero: item.returnRate === 0,
                  }">{{ formatPercent(item.returnRate) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-data" v-else>
          <empty image="error" description="暂无持仓" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import IcpInfo from "@/components/IcpInfo.vue";
import { fetchUserReturnInfo } from "@/api/theApi";
import { Empty } from "vant";

export default {
  name: "StrategyAnalytics",
  components: {
    Empty,
    // IcpInfo,
  },
  data() {
    return {
      positionInfo: {
        totalBalance: 0,
        cashBalance: 0,
        positionBalance: 0,
        totalFloatPL: 0,
        todayFloatPL: 0,
        todayFloatRate: 0,

      },
      positionList: [],
    };
  },
  async created() {
    await this.initData();
  },
  mounted() {
    this.checkPageHeight();
    window.addEventListener('resize', this.checkPageHeight);
  },
  updated() {
    // 数据更新后重新检测
    this.$nextTick(() => {
      this.checkPageHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkPageHeight);
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/user");
      }
    },
    // 处理表格滚动事件
    handleTableScroll(event) {
      const scrollLeft = event.target.scrollLeft;
      const fixedElement = this.$refs.fixedColumn;

      if (fixedElement) {
        if (scrollLeft > 0) {
          fixedElement.classList.add("show-shadow");
        } else {
          fixedElement.classList.remove("show-shadow");
        }
      }
    },
    isPositivePercent(percentStr) {
      if (!percentStr) return false;
      const numValue = parseFloat(percentStr.replace("%", ""));
      return !isNaN(numValue) && numValue > 0;
    },
    // 格式化数字，添加千位分隔符
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) return "0";
      return Number(num).toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },
    // 格式化货币
    formatCurrency(num) {
      if (num === null || num === undefined || isNaN(num)) return "0";
      return "¥ " + Number(num).toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },
    // 格式化百分比
    formatPercent(decimal) {
      if (decimal === null || decimal === undefined || isNaN(decimal)) return "0%";
      const percent = (decimal).toFixed(2);
      return `${decimal > 0 ? '+' : ''}${percent}%`;
    },
    // 格式化盈亏金额
    formatPL(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return "0";
      const formatted = Number(amount).toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      return `${amount > 0 ? '+' : ''}${formatted}`;
    },
    async initData() {
      // this.strategyId = await this.$route.params.id;
      // const res1 = await fetchStrategyV2(
      //   this.strategyId,
      //   localStorage.getItem("username")
      // );
      const res = await fetchUserReturnInfo();
      const { data } = res || {};
      this.positionInfo = data && data.positionInfo || {};
      this.positionList = data && data.positionList;
    },
    // 检测页面高度是否超出屏幕高度
    checkPageHeight() {
      this.$nextTick(() => {
        // 获取整个页面的实际高度
        const bodyHeight = document.body.scrollHeight;
        // 获取视窗高度
        const viewportHeight = window.innerHeight;
        
        // 如果页面内容高度超出视窗高度，说明会出现滚动条
        // 这时不需要给 mid 设置固定高度
        this.shouldSetMidHeight = bodyHeight <= viewportHeight;
      });
    },
  },
};
</script>

<style lang="less" scoped>
#strategy-analytics {

  .ai-live-date {
    position: absolute;
    right: 1px;
    bottom: 3px;
    .current-date {
      font-size: 14px;
      color: #8e8e93;
    }
  }

  .top {
    .returns {
      display: block;
      width: 24px;
      height: 24px;
      margin: 16px;
    }
  }

  .performance-metrics {
    background: #fff;
    height: 74px;
    padding: 16px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    margin: 0 16px;
  }

  .metric-item {
    flex: 1;

    .metric-label {
      font-size: 12px;
      color: #8e8e93;
      line-height: 1.5;
      margin-bottom: 4px;
    }

    .metric-value {
      font-size: 17px;
      font-weight: 600;
    }
  }

  .chart-section {
    margin: 24px 0;
  }

  .chart-section,
  .transaction-section {
    margin: 0 16px;

    &.swiper {
      margin-right: 0;
    }
  }

  .chart-title-bar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 24px;
    line-height: 1.5;
    color: #333;
    position: relative;

    &.single {
      margin: 24px 16px 0;
    }
  }

  .section-subtitle {
    color: #8e8e93;
    font-size: 14px;
    line-height: 1.5;
    margin-right: 16px;
  }

  .chart-container {
    display: flex;
    overflow-x: auto;
    padding-bottom: 8px;

    &.echart-container {
      padding: 8px 4px;
      border-radius: 8px;
      background: #ffffff;
      flex-direction: column;
      align-items: flex-start;
    }

    .chart-button {
      padding-left: 8px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      column-gap: 8px;
      margin-bottom: 8px;
      .chart-button-item {
        padding: 5px 10px;
        background: #0000000d;
        border-radius: 4px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 12px;
        line-height: 130%;
        letter-spacing: 0.67%;
        color: #0000007a;
        &.active-button {
          background: #000000;
          color: #ffffff;
        }
      }
    }
  }

  .line {
    border-radius: 8px;
    overflow: hidden;
    margin: 0;
    min-width: 100%;
  }

  .transaction-section {
    background-color: #fff;
    margin: 12px 16px;
    padding: 16px;
    border-radius: 8px;
  }

  .tab-buttons {
    display: flex;
    margin-bottom: 16px;
    border-radius: 90px;
    overflow: hidden;
    background-color: #edeff3;
    padding: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .tab-button {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
    color: #878b91;
    font-weight: 500;
    border-radius: 90px;
    transition: all 0.3s ease;
    position: relative;
    cursor: pointer;

    &.active {
      background-color: #fff;
      color: #000000;
      font-weight: 600;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    }

    &:not(.active):hover {
      color: #000000;
      background-color: rgba(255, 255, 255, 0.5);
    }
  }

  .transaction-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }

  .transaction-item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    word-break: break-all;
    column-gap: 8px;

    span {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      letter-spacing: 0px;
      color: #00000099;

      &.transaction-buy {
        color: #4899a4;
        font-weight: 500;
      }
      &.transaction-sell {
        color: #d68b49;
        font-weight: 500;
      }
      &.positive-rate {
        color: #e1456e;
        font-weight: 500;
      }
      &.negative-rate {
        color: #34c759;
        font-weight: 500;
      }
    }
  }

  .mid {
    background-color: #f5f5f5;
    padding-bottom: 60px;
    
    &.fixed-height {
      height: calc(100vh - 108px);
    }
  }

  .date-range-picker {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0;
  }

  .date-input {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

    span {
      font-size: 14px;
      color: #333;
    }
  }

  .dropdown-icon {
    width: 16px;
    height: 16px;
    margin-left: 4px;
  }

  .date-separator {
    margin: 0 12px;
    font-size: 14px;
    color: #666;
  }

  .section-desc {
    margin-top: 14px;
    background: #f7f7f8;
    padding: 12px;
    border-radius: 8px;

    .desc-title {
      color: #000;
      font-size: 16px;
      font-weight: 600;
      font-family: PingFangSC-Medium;
    }

    .desc-content {
      margin-top: 8px;
      color: rgba(0, 0, 0, 0.6);
      font-size: 12px;
      line-height: 1.5;
      font-weight: 400;
      text-align: justify;
      max-height: 60px;
      overflow: hidden;
      position: relative;
      transition: max-height 0.3s ease;
      cursor: pointer;

      &.expanded {
        max-height: 1000px;
      }

      &:not(.expanded)::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 24px;
        background: linear-gradient(
          to bottom,
          rgba(247, 247, 248, 0),
          rgba(247, 247, 248, 1)
        );
        pointer-events: none;
      }
    }

    .expand-trade {
      text-align: center;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      padding: 12px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      margin-top: 4px;

      .dropdown-icon {
        width: 14px;
        height: 14px;
        margin-left: 4px;
        transition: transform 0.3s;

        &.rotate-icon {
          transform: rotate(180deg);
        }
      }
    }
  }

  .bottom {
    bottom: 0;
    height: 50px;
    position: fixed;
    width: 100%;
    z-index: 999;
  }

  .image-contain {
    background: #fff;
    margin-right: 8px;
    width: 150px;
    height: 156px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    .image-inner {
      display: block;
      width: 140px;
      height: 140px;
      object-fit: cover;
    }
  }

  .total-assets {
    background: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    margin: 12px 16px;
  }

  .assets-label {
    font-size: 13px;
    color: #8e8e93;
    line-height: 1.5;
  }

  .assets-value {
    font-size: 28px;
    font-family: PingFangSC-Bold;
    font-weight: 700;
    color: #000;
    line-height: 1.5;
  }

  .assets-change {
    font-size: 12px;
    line-height: 1.5;
    margin-left: 4px;

    &.positive {
      color: #d70000;
    }

    &.negative {
      color: #48bb78;
    }

    &.zero {
      color: #8e8e93;
    }
  }

  .asset-stats {
    background: #fff;
    padding: 16px;
    border-radius: 8px;
    margin: 12px 16px;
  }

  .stat-row {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    &:last-child {
      margin-bottom: 0;
      margin-top: 8px;
    }
  }

  .stat-item {
    flex: 1;
  }

  .stat-label {
    font-size: 13px;
    line-height: 1.5;
    color: #8e8e93;
  }

  .stat-value {
    font-size: 14px;
    line-height: 1.5;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #000;

    &.positive {
      color: #d70000;
    }

    &.negative {
      color: #48bb78;
    }
  }

  .holdings-section {
    background-color: #fff;
    margin: 12px 16px;
    padding: 16px;
    border-radius: 8px;
  }

  .holdings-table {
    display: flex;
    width: 100%;
    position: relative;

    /* 添加右侧渐变阴影提示可滚动 */
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 20px;
      height: 100%;
      background: linear-gradient(
        to left,
        rgba(255, 255, 255, 0.8),
        transparent
      );
      pointer-events: none;
      z-index: 1;
    }
  }

  .fixed-column {
    width: 80px;
    flex-shrink: 0;
    background: #fff;
    z-index: 2;
    position: relative;

    /* 阴影伪元素 */
    &.show-shadow::after {
      content: "";
      position: absolute;
      top: 0;
      right: -6px;
      width: 6px;
      height: 100%;
      background: linear-gradient(to right, rgba(0, 0, 0, 0.06), transparent);
      pointer-events: none;
      transition: opacity 0.3s ease;
      opacity: 1;
    }
  }

  .fixed-header {
    font-size: 12px;
    color: #00000099;
    padding: 8px 4px 2px;
    line-height: 1.5;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 6px;
    text-align: left;
  }

  .fixed-content {
    display: flex;
    flex-direction: column;
  }

  .fixed-cell {
    font-size: 12px;
    line-height: 1.5;
    color: #000000;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    padding: 10px 4px;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .scrollable-columns {
    flex: 1;
    overflow-x: auto;
    position: relative;
    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }

  .scrollable-header {
    display: flex;
    min-width: 400px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 6px;
  }

  .scrollable-header-cell {
    flex: 1;
    min-width: 80px;
    font-size: 12px;
    color: #00000099;
    padding: 8px 4px 2px;
    line-height: 1.5;
    text-align: center;
  }

  .scrollable-content {
    display: flex;
    flex-direction: column;
  }

  .scrollable-row {
    display: flex;
    min-width: 400px;
    align-items: center;
  }

  .scrollable-cell {
    flex: 1;
    min-width: 80px;
    font-size: 12px;
    line-height: 1.5;
    color: #333;
    text-align: center;
    padding: 10px 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.positive {
      color: #d70000;
    }

    &.negative {
      color: #48bb78;
    }

    &.zero {
      color: #8e8e93;
    }
  }

  .empty-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    background-color: #fff;
    margin: 12px 16px;
    padding: 16px;
    border-radius: 8px;
  }
}
</style>
